import React, { Component } from "react";
import { connect } from "react-redux";

import "./LicenseNoPermission.component.scss";

export interface LicenseNoPermissionProps {
    message: string;
}

class LicenseNoPermission extends Component<LicenseNoPermissionProps, {}> {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <React.Fragment>
                <div id="LicenseNoPermission">
                    <div className="mgmt-info">
                        <p>{this.props.message}</p>
                    </div>
                </div>
            </React.Fragment>
        );
    }
}

const mapStateToProps = state => ({});

const mapDispatchToProps = {};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(LicenseNoPermission);
